<app-card-layout>
  <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="text-center mb-4">
      <img src="/assets/app/img/brand-icon.png" height="64" alt="Zscaler" />
    </div>
    <div class="text-center lh-125">
      <h5>Reset Password</h5>
      <small class="text-secondary">
        Enter your email address and we will send you a link to create a new
        password.
      </small>
    </div>
    <hr class="w-25 my-4" />

    <div class="form-group">
      <label for="mail">Email address</label>
      <input
        id="email"
        formControlName="email"
        [ngClass]="{ 'is-invalid': isInvalidEmail() }"
        type="email"
        class="form-control"
        placeholder="Enter your email address&hellip;"
        maxlength="320"
        required
      />
      <div class="invalid-feedback">Please enter a valid email address.</div>
    </div>

    <div class="mb-4">
      <button
        [disabled]="isLoading"
        type="submit"
        class="btn btn-primary btn-block"
      >
        Reset password
      </button>
    </div>

    <div class="text-center small">
      <a routerLink="/login">Back to login</a>
    </div>
  </form>
</app-card-layout>
